import * as types from '@portal/common/store/session/types';

type Action = {
    type: keyof typeof types;
    payload?: { error?: string | null };
};

export default function (state: string | null = null, action: Action): string | null {
    switch (action.type) {
        case types.SESSION_SIGNED_OUT:
            return action.payload?.error ?? null;

        case types.SESSION_SIGNED_IN:
            return null;

        default:
            return state;
    }
}
